// extracted by mini-css-extract-plugin
export var chevron = "_il-2";
export var dropdownItems = "_il-0";
export var item = "_il-1";